import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.6609 12.7554C23.8688 12.5722 24 12.3039 24 12.0049C24 11.9043 23.9851 11.8071 23.9574 11.7154C23.9116 11.5615 23.8279 11.4165 23.7063 11.295L17.71 5.2929C17.3195 4.90237 16.6805 4.90237 16.29 5.29289C15.8995 5.68341 15.8995 6.32237 16.2901 6.7129L20.5862 11.0049L1 11.0049C0.447715 11.0049 -2.82055e-07 11.4527 -3.06196e-07 12.0049C-3.30337e-07 12.5572 0.447715 13.0049 1 13.0049L20.5813 13.0049L16.29 17.2921C15.8995 17.6826 15.8995 18.3216 16.29 18.7121C16.6805 19.1026 17.3195 19.1026 17.71 18.712L23.6609 12.7554Z"
  }));
});
var NavigationArrowForward = AbstractIcon.withComponent(Icon);
NavigationArrowForward.displayName = 'NavigationArrowForward';
export default NavigationArrowForward;